import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  loading: { height: '100vh' },
  chevron: {
    marginTop: theme.spacing(1)
  },
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
  },
  image: {
    width: '100%'
  },
  pushRight: {
    marginRight: theme.spacing(2)
  },
  genre: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  descriptionText: {
    color: theme.palette.grey[700],
    fontWeight: 500
  },
  durationContainer: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: theme.spacing(1)
    }
  },
  duration: {
    textTransform: 'initial',
    backgroundColor: theme.palette.primary.main,
    padding: '.5em',
    borderRadius: theme.shape.borderRadius,
    color: 'white'
  },
  title: {
    marginBottom: theme.spacing(2)
  }
}))